import React from 'react'
import { Button, Image } from 'antd'
import { EyeOutlined } from '@ant-design/icons'

const PreviewButton = (props: any) => {
  const { visible, setVisible, src } = props

  return (
    <>
      <Button
        type='text'
        className='radius-100'
        icon={<EyeOutlined />}
        onClick={() => setVisible(true)}
      />
      <Image
        width={200}
        style={{ display: 'none' }}
        alt={'image-logo'}
        src={src}
        preview={{
          visible,
          src,
          onVisibleChange: value => {
            setVisible(value)
          },
        }}
      />
    </>
  )
}

export default PreviewButton
